declare var require: any;

import { Component, Inject, OnInit } from "@angular/core";
import {
  Validators,
  FormBuilder,
  FormControl,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-area-insert-by-geo-json",
  templateUrl: "./area-insert-by-geo-json.component.html",
  styleUrls: ["./area-insert-by-geo-json.component.scss"],
})
export class AreaInsertByGeoJsonComponent implements OnInit {
  newAreaForm = this.fb.group({
    areaName: [null, Validators.required],
    geoArea: [null, Validators.compose([Validators.required, validateGeoJson])],
  });

  constructor(
    public dialogRef: MatDialogRef<AreaInsertByGeoJsonComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    const formValue = this.newAreaForm.value;
    this.dialogRef.close(formValue);
  }

  closeCancelling() {
    this.dialogRef.close();
  }
}

export function validateGeoJson(
  control: AbstractControl
): ValidationErrors | null {
  try {
    const geoJson = JSON.parse(control.value);
    const gjv = require("geojson-validation");
    if (!gjv.valid(geoJson)) {
      return { invalidGeoJson: true };
    }
  } catch (e) {
    return { invalidGeoJson: true };
  }
  return null;
}
